import React, { Component } from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import './Timeline.css';

/****************************************************************
PROPS :
listeEtapes : liste des étapes à afficher { numEtape, icone, nomEtape, sousTitre, tooltip, onClick }
etapeActive : étape sélectionnée en cours
****************************************************************/

export class Timeline extends Component {
    componentDidMount() {
        //méthode appelée lors du montage du composant
    }

    componentDidUpdate() {
        //méthode appelée lors de la mise à jour du composant
    }

    componentWillUnmount() {
        //immédiatement avant le démontage du composant. NE JAMAIS APPELER SetState ICI
    }

    render() {
        let timelineEtapes = [];
        let etapeEnCours = this.props.etapeActive;
        let listEtapes = this.props.listeEtapes;

        listEtapes.forEach(function (etape) {
            timelineEtapes.push(
                <li key={etape.numEtape} className={`etapeListeItem` + (etapeEnCours === etape.numEtape ? ` etapeListeItem--active` : ``)} title={etape.tooltip !== undefined ? `${etape.tooltip}` : ''} onClick={etape.onClick}>
                    <Icon iconName={etape.icone} className="etapeIcone" />
                    <span className="etapeTitre">{`${etape.numEtape}. ${etape.nomEtape}`}</span>
                    <span className="etapeSousTitre">{etape.sousTitre}</span>
                </li>);
        });

        return (listEtapes.length > 0 ?
            <div className={this.props.sansContainer ? "" : "containerTimeline"}>
                <nav className="etape">
                    <ul className="etapeListe">
                        {timelineEtapes}
                    </ul>
                </nav>
            </div>
            : null);
    }
}